import gql from 'graphql-tag'

// NOTE: this calls the listActivityByUser2 api, not the original listActivityByUser
export default gql`
query listActivitiesByUser($username: String){
    listActivitiesByUser: listActivitiesByUser2(username: $username) {
        items {
            id
            actDate
            username
            activityType
            value
            intensity
            notes
            timestamp
        }
    }
}`



// WEBPACK FOOTER //
// ./src/components/queries/ListActivitiesByUserQuery.js